import React from "react"
import ContactForm from "../../../components/shared/contact"
import Footer from "../../../components/shared/footer"
import Layout from "../../../components/shared/layout"
import SEO from "../../../components/shared/seo"
import Hero from "./hero"
import Clients from "./clients"
import Overview from "./overview"
import ServiceNowClientPromo from "./service-now-client-promo"
import BottomSection from "./bottom-section"
import BlogFeatures from "./blog-features"

export default function SecurityPage({ location }) {
    return (
        <Layout location={location} >
            <SEO
                title="Security"
                description="Mappedin prides itself on keeping the security of our mapping software at the heart of our product, infrastructure, and company policies. With millions of square feet of indoor maps in our system, our clearly defined approach to data security is critical."
            />
            <Hero
                title="Keeping Your Mapping Data Safe With Mappedin"
                description="Mappedin prides itself on keeping the security of our mapping software at the heart of our product, infrastructure, and company policies. With millions of square feet of indoor maps in our system, our clearly defined approach to data security is critical."
            />
            <Clients />
            <Overview />
            <ServiceNowClientPromo />
            <BottomSection />
            <BlogFeatures />
            <ContactForm />
            <Footer />
        </Layout>
    )
}